import React, { useEffect, useState, useContext, useRef } from 'react';
import { IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonList, IonItem, IonicSlides, IonText, IonAlert, IonInput, IonIcon, IonLoading } from '@ionic/react';
import { useIonRouter, IonSlide, IonRow, IonCol, IonImg, IonRefresher, IonRefresherContent } from '@ionic/react';
import { Route, useHistory} from "react-router-dom";
import { Http } from '@capacitor-community/http';
import { searchOutline, filter, options } from 'ionicons/icons'; // Import the search icon


//import { NativeBiometric } from "capacitor-native-biometric";
//import { BiometryType } from "capacitor-native-biometric";



import { Public_MerchantID_Context } from '../../../storeState/public_merchantID_context';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { Hotel_PrivacyStatement } from '../components/PrivacyStatement';

import {RegisterBusinessModal} from '../components/Register_Business_Modal';
import {RegisterIndividualModal} from '../components/Register_Individual_Modal';

import {AboutModal} from '../components/Modal_About';

import {Search_Home} from '../components/Component_Search_Home';

import {Home_HotelsList} from '../components/Component_Home_Hotel';
import {Home_ProfessionalServicesList} from '../components/Component_Home_ProService';
import {Home_RetailServicesList} from '../components/Component_Home_RetailList';
import {Home_JobsList} from '../components/Component_Home_JobsList';
import { MerchantLoginCredentials } from '../components/LoginCredentials_merchant';

import {ConfirmMerchantLogout} from '../components/MerchantLogout';

import { CreateRequisitionModal_Public } from '../components/Modal_CreateRequisition_Public';


import '../../css/layout.css'

export function Home (props) {


    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [acctID, setAcctID ] = useState(authMerchant_objects.acctID);
    let [schema, setSchemaName] = useState(authMerchant_objects.schema);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);
    //let [accounts_merchant, setAccounts_merchant ] = useState(authMerchant_objects.accounts_merchant);
    //let [accounts_user, setAccounts_user] = useState(authMerchant_objects.accounts_user);
    let [sessionID, setSessionID ] = useState(authMerchant_objects.sessionID);

    //alert('In HOME')
    let [homeView, setHomeView] = useState(null);

    let [merchantLoginModal, setMerchantLoginModal] = useState(false);
    let [clientLoginModal, setClientLoginModal] = useState(false);
    let [privacyStatementModal, setPrivacyStatementModal] = useState(false);

    let [showAlert, setShowAlert] = useState(false);

    let [registerModal_business, setRegisterModal_business] = useState(false);
    let [registerModal_individial, setRegisterModal_individual] = useState(false);

    let [aboutOpen, setAboutOpen] = useState(false);


    //let [isBiometric_fingerprintAvilable, setIsBiometric_fingerprintAvilable ] = useState(authMerchant_objects.isBiometric_fingerprintAvilable);
    //let [biometric_fingerprint, setBiometric_fingerprint] = useState(authMerchant_objects.biometric_fingerprint);
    //let [device, setDevice ] = useState(authMerchant_objects.device);

    let publicMerchent_context = useContext(Public_MerchantID_Context);

    let [searchHomeList, setSearchHomeList] = useState('false');


    let [hotelList_component, setHotelList_component] = useState('true');
    let [proList_component, setProlList_component] = useState('false');
    let [retailList_component, setRetailList_component] = useState('false');
    let [jobsList_component, setJobsList_component] = useState('false');

    let [color_hotels, setColor_hotels] = useState('outline')
    let [color_proServices, setColor_proServices] = useState('clear')
    let [color_retail, setColor_retail] = useState('clear')
    let [color_jobs, setColor_jobs] = useState('clear')

    let [searchTerm, setSearchTerm] = useState(null);
    let [searchResults, setSearchResults] = useState([]);

    let [isloading, setLoading] = useState(false);

    let [selectedAccountID, setSelectedAccountID] = useState(null);
    let [selectedAccountName, setSelectedAccountName] = useState(null);
    let [selectedAccountUsername, setSelectedAccountUsername] = useState(null);
    let [selectedAccountPassword, setSelectedAccountPassword] = useState(null);

    let [switchAccounts_logout, setSwitchAccounts_logout] = useState(false);
    let [switchAccounts_login, setSwitchAccounts_login] = useState(false);

    let [viewAccountList, setViewAccountList] = useState([]);
    let [createRequisitionModal, setCeateRequisitionModal] = useState(false);

    let history = useHistory();
    let router = useIonRouter();

    let slideRef = useRef(null);

    let timeout;


    function handleInput(event) {

        //alert("In Handle Input");
        setSearchTerm('');
        setLoading(true);

        document.getElementById('searchSupplierNameList').innerHTML = '';

        clearTimeout(timeout); // Clear the previous timeout to reset the delay

        setSearchTerm(event[1]);
        timeout = setTimeout(searchSupplierList(event), 2000); // Set a new timeout

    
    }


    function searchSupplierList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchSuppliersInDB(searchCategory, searchData);
    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {

        let formData = new FormData();
        let Tracker = '';


        if(searchCategory === 'search_home')
        {

            Tracker = '74002S_search_home';
        }

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xSupplierSearchName: searchData,
                //sessionID: sessionID,
            })
        }

        fetch(baseURL+'merchants_argsApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;


                        // alert("After Fetch");
                        // alert(res);
                        // alert(searchCategory);
                        // alert(rowLength);
                        // alert(rows);

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                if(searchCategory === 'search_home')
                                {
                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            id: cols[0],
                                            companyName: cols[1],
                                        })
                                    });
                                    //document.getElementById('searchSupplierNameList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], searchCategory,]+'\'>'+cols[0]+'</option>'); // onclick=\'inventoryItemsSearchResults('+cols[0]+')\'
                                }
                            }

                            if(rowLength >= 1)
                            {
                                setSearchHomeList('false');
                                setSearchHomeList('true');
                                setLoading(false);
                            }
                    })
        }



    function handleSearch(e) {

        setSearchTerm(e.target.value);

      };

    function hotelsHandler()
    {
        setHotelList_component('true');
        setProlList_component('false');
        setRetailList_component('false');
        setJobsList_component('false');

        setColor_hotels('outline');
        setColor_proServices('clear');
        setColor_retail('clear');
        setColor_jobs('clear');


    }
    function proServicesHandler()
    {
        setHotelList_component('false');
        setProlList_component('true');
        setRetailList_component('false');
        setJobsList_component('false');

        setColor_hotels('clear');
        setColor_proServices('outline');
        setColor_retail('clear');
        setColor_jobs('clear');

    }
    function retailHandler()
    {
        setHotelList_component('false');
        setProlList_component('false');
        setRetailList_component('true');
        setJobsList_component('false');

        setColor_hotels('clear');
        setColor_proServices('clear');
        setColor_retail('outline');
        setColor_jobs('clear');

    }
    function jobsHandler()
    {
        setHotelList_component('false');
        setProlList_component('false');
        setRetailList_component('false');
        setJobsList_component('true');

        setColor_hotels('clear');
        setColor_proServices('clear');
        setColor_retail('clear');
        setColor_jobs('outline');

    }
    function searchItemHandler()
    {
        setHotelList_component('false');
        setProlList_component('false');
        setRetailList_component('false');

        setSearchHomeList('true');

        setColor_hotels('clear');
        setColor_proServices('clear');
        setColor_retail('clear');

    }

    function zPub_handleMerchantID(event) {

        publicMerchent_context.changeCompanyID(event[0]);
        publicMerchent_context.changeCompanyName(event[1]);

    }

    function resetToolbarHandler(event) {

        publicMerchent_context.changeCompanyID(null);
        publicMerchent_context.changeCompanyName('ghanaverified');

    }

    async function handleSlideChange()
    {

        //alert("In Handle Slide Change");
        let swiper = await slideRef.current?.getSwiper();

        //let activeIndex = swiper?.activeIndex; // Get the current slide index

        let realIndex = swiper?.realIndex; // Get the actual slide index (ignores duplicate slides)

        //alert(realIndex);
    
        if (realIndex === 0) { // Example: Execute a function when reaching slide 3
            hotelsHandler();
        }
        else if (realIndex === 1) { // Example: Execute a function when reaching slide 3
            proServicesHandler();
        }
        else if (realIndex === 2) { // Example: Execute a function when reaching slide 3
            retailHandler();
        }
        else if (realIndex === 3) { // Example: Execute a function when reaching slide 3
            jobsHandler();
        }
        // else if (realIndex === 3) { // Example: Execute a function when reaching slide 3
            
        //     if(searchHomeList == 'true')
        //     {
        //         searchItemHandler();
        //     }
        //     else
        //     {
        //         swiper.slideTo(0, 100); // Redirect back if trying to access slide 3
        //        // hotelsHandler();
        //     }
        // }
      };

    function handleRegister_business() {

        authMerchant_objects.changeAccountID('register_request');
        setRegisterModal_business(true);
    }

    function handleRegister_individual() {

        authMerchant_objects.changeAccountID('register_request');
        setRegisterModal_individual(true);
    }

    const handleHomepage = () => {

        //alert("in handle homepage");
        //alert(authMerchant_objects.authenticated);

            if(authMerchant_objects.authenticated == 'T1')
            {
                //history.push('/hotel_merchantMainPageApp');
                router.push('/hotel_merchantMainPageApp', 'forward', 'replace');

            }
            else if(authMerchant_objects.authenticated == 'T2')
            {
                //history.push('/proService_merchantMainPageApp'); 
                router.push('/proService_merchantMainPageApp', 'forward', 'replace');

            }
            else if(authMerchant_objects.authenticated == 'T3')
            {
                //history.push('/retail_merchantMainPageApp'); 
                router.push('/retail_merchantMainPageApp', 'forward', 'replace');

            }
            else if(authMerchant_objects.authenticated == 'T4')
            {
                //history.push('/retail_merchantMainPageApp'); 
                router.push('/jobBoard_merchantMainPageApp', 'forward', 'replace');

            }
            else if(authMerchant_objects.authenticated == 'C1')
            {
                //history.push('/clientMainPageApp'); 
                router.push('/clientMainPageApp', 'forward', 'replace');

            }
      };


    const handleHomepage_zasava = () => {

        if (baseURL === "https://ghanaverified.com/") {
            window.location.href = "https://zasava.com";
        } 
        else if (baseURL === "https://ghanaverifiedtest.com/") {
            window.location.href = "https://zasavatest.com";
        }
  };

    const slideOpts = {
        initialSlide: 0, // Start at the first slide
        speed: 100, // Animation speed (in ms)
        loop: false, // Enable looping
      };

    
    function handleCloseModal()
    {
        authMerchant_objects.changeAccountID(null);   
        setRegisterModal_business(false);
        setRegisterModal_individual(false);
    }

    async function reRender() 
    {
        //alert("DataRetrieved 1");
        let swiper = await slideRef.current?.getSwiper();
        //alert("DataRetrieved 2");

        slideRef.current.update();
        //alert("DataRetrieved 3");

        if(searchHomeList == 'true')
        {
            swiper.slideTo(3, 0); // Instantly switch to the specified slide
            swiper.allowTouchMove = false; // Prevent further navigation
            searchItemHandler();
        }


    }

    async function reOpenSwipe(event) 
    {
        //alert("DataRetrieved");
        //alert(event);
        
        let swiper = await slideRef.current?.getSwiper();

        if(searchHomeList == 'true')
        {
            setSearchHomeList('false');
            swiper.allowTouchMove = true; // Allow further navigation
            setSearchTerm('');

        // Wait for state to update before proceeding
            setTimeout(() => {  

                if (event === 0) {
                    
                    // Force move to index 1 first, then back to 0
                    slideRef.current?.slideTo(1, 100);  
    
                    setTimeout(() => {
                        slideRef.current?.slideTo(0, 100);
                    }, 50); // Small delay to ensure state change
                } else {
                    slideRef.current?.slideTo(event, 100);
                }
            }, 0); // A small delay to ensure state updates before calling slideTo
        }
        else
        {
            slideRef.current?.slideTo(event, 100);
            setSearchHomeList('false');
        }


    }
    function safeJsonParse(jsonString) {
        return (typeof JSON.parse === 'function') ? JSON.parse(jsonString) : null;
      }

    function handleRefresh(event)
    {
        // Optional: Delay to show the spinner briefly
        setTimeout(() => {
        event.detail.complete();   // Stop the spinner
        window.location.reload();  // Reload the entire app
        }, 500);
    }

    function handleAccountChange(event)
    {

        //alert("In Account Change");
        //alert(event);

        let selectBox = event.target; // Use event.target to get the IonSelect
        let selectedValue_id = selectBox.value; // Get the selected value (room ID)

        let selectedOption = Array.from(selectBox.children).find(option => option.value === selectedValue_id);

        let selectedValue_name = selectedOption.getAttribute('data-name');
        let selectedValue_username = selectedOption.getAttribute('data-username');
        let selectedValue_password = selectedOption.getAttribute('data-password');

        setSelectedAccountID(selectedValue_id);
        setSelectedAccountName(selectedValue_name);
        setSelectedAccountUsername(selectedValue_username);
        setSelectedAccountPassword(selectedValue_password);

        setSwitchAccounts_logout(true);


    }

    function getAccountList()
    {
       // alert('In GET TUTORIALS Setting ');

       // setViewTutorialsList([]);

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {'content-type': 'application/json' },
                body: JSON.stringify({
                    Tracker: "00_retrieveAccountList",
                    user: acctID,
                    sessionID: sessionID,
                }),
            }


            //alert("IN SELLECT ROOOM");
            //fetch(newBaseURL+'/public_request', requestOptions)
            fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {


                            setViewAccountList([]);

                            let rows = res.toString().split('~~~');
    
                            let rowLength = rows.length;


    
                                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                                {
                                    let cols = rows[rownum].split('|');

                                    setViewAccountList((prevSetViewAccountList) => {
                                        return prevSetViewAccountList.concat({
                                            id: cols[0],
                                            name: cols[1],
                                            username: cols[2],
                                            password: cols[3],
                                        })
                
                                    });
    
                                }

                                setLoading(false);

                            
                        }, 'html')
    };

    function loggedOutHandler()
    {
        //alert("in loggedOutHandler");

        setSwitchAccounts_logout(false);
        setSwitchAccounts_login(true);

    }
    
    function registationCompletedHandler(event)
    {
        // alert("in registationCompletedHandler");
        // alert(event);
        // alert(event[0]);
        // alert(event[1]);

        setSelectedAccountUsername(event[0]);
        setSelectedAccountPassword(event[1]);
        setSwitchAccounts_login(true);

    }

    useEffect(() =>{

        if(authMerchant_objects.authenticated != null )
        {
            getAccountList();
        }

    }, [])

    useEffect(() => {

        //alert(props.data.status);

        //if(props.data.status == 'public_jobs')
        if (window.location.pathname === "/jobs")
        {
         //   reOpenSwipe(3);

            setHotelList_component('false');
            setProlList_component('false');
            setRetailList_component('false');
            setJobsList_component('true');

            // Highlight the Jobs button
            setColor_hotels('clear');
            setColor_proServices('clear');
            setColor_retail('clear');
            setColor_jobs('outline');

            // If you want to force the slide index:
            setTimeout(async () => {
            const swiper = await slideRef.current?.getSwiper();
            swiper?.slideTo(3, 0);
            }, 100);

        }

    }, [])

    //alert("In Homme");
    //alert(window.location.pathname)
    //alert(authMerchant_objects.authenticated);
    // // alert(authMerchant_objects.acctID);
    //  alert(authMerchant_objects.initialSetup);
    //  alert(authMerchant_objects.initialSetup.details);
    //  alert(authMerchant_objects.initialSetup?.details?.step_1);
    //alert(JSON.parse(authMerchant_objects.initialSetup.details)?.step_1);

    // alert(authMerchant_objects.initialSetup.setup_id);
    // alert(authMerchant_objects.initialSetup?.details?);
    //alert(authMerchant_objects.initialSetup?.details?.step_1);
    //alert(safeJsonParse(authMerchant_objects.initialSetup[1]));
    //alert(authMerchant_objects.initialSetup?.details?);

    //alert(authMerchant_objects.accounts_merchant);
    //alert(authMerchant_objects.accounts_user);
    // alert(authMerchant_objects.accounts_merchant?.id);
    // alert(authMerchant_objects.accounts_merchant?.merchantName);
    // alert(authMerchant_objects.accounts_merchant?.username);
    // alert(authMerchant_objects.accounts_merchant?.password);

    // alert(authMerchant_objects.accounts_user?.id);
    // alert(authMerchant_objects.accounts_user?.customerName);
    // alert(authMerchant_objects.accounts_user?.username);
    // alert(authMerchant_objects.accounts_user?.password);


      useEffect(() => {
    // SEO BLOCK START
    document.title = "Ghana Verified Jobs – Find Jobs in Ghana | Post a Job";

    const descriptionTag = document.querySelector("meta[name='description']");
    if (descriptionTag) {
      descriptionTag.setAttribute("content", "Find jobs in Ghana...");
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = "Find jobs in Ghana...";
      document.head.appendChild(meta);
    }

    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = "https://ghanaverified.com/jobs";
    document.head.appendChild(canonical);

    function setOg(prop, content) {
      let tag = document.querySelector(`meta[property='${prop}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", prop);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    }

    setOg("og:title", "Ghana Verified Jobs – Find Jobs in Ghana");
    setOg("og:description", "Search and post jobs across Ghana instantly.");
    setOg("og:url", "https://ghanaverified.com/jobs");
    setOg("og:type", "website");
    setOg("og:image", "https://ghanaverified.com/assets/logo.png");
    // 🔥 SEO BLOCK END
  }, []);


    return (
            <React.Fragment>

                <IonHeader >
                        <IonToolbar className="grid_header_componentSlides" color="dark">
                        <IonGrid  >
                           {authMerchant_objects.authenticated == null && <IonRow className='gh_top_links_row'>
                                    <IonCol size='6' style={{ fontSize: "16px", textAlign: "left"}} ><a onClick={() => setShowAlert(true)}>Register</a></IonCol>
                                    <IonCol size='3' style={{ fontSize: "16px", textAlign: "center"}} ><a onClick={() => setAboutOpen(true)}>About Us</a></IonCol>
                                    <IonCol size='3' style={{ fontSize: "16px", textAlign: "center"}} >
                                        <a  onClick={() => setMerchantLoginModal(true)}>Login</a>
                                        <a > </a>
                                    </IonCol>
                                    {/*<div style={{ fontSize: "16px", display: "flex", gap: "10px" }} >
                                        <a  onClick={() => setMerchantLoginModal(true)}>Sign-in</a>
                                        <a  >Contact</a>
                                    </div>*/}
                            </IonRow>}
                            {authMerchant_objects.authenticated != null && 
                            <IonRow className='gh_top_links_row'>
                                    <IonCol size='6' style={{ fontSize: "16px", textAlign: "left"}}>
                                        <a>
                                            <select id='searchAvailableRooms'  value={acctID} style={{ fontSize: ".5em" }} onChange={handleAccountChange}>
                                            <option value="" disabled>Change Account</option>
                                            {viewAccountList.map(account => (
                                                    <option 
                                                        key={account.id} 
                                                        value={account.id} 
                                                        data-name={account.name} 
                                                        data-username={account.username} 
                                                        data-password={account.password} 
                                                    >
                                                    Acct - {account.id}: Name - {account.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </a>
                                    </IonCol>
                                    <IonCol size='4' style={{ fontSize: "16px", textAlign: "right"}} ><a onClick={() => setAboutOpen(true)}>About Us</a></IonCol>
                                    {(authMerchant_objects.initialSetup?.details?.step_1 == false || authMerchant_objects.initialSetup?.details?.step_2 == false || authMerchant_objects.initialSetup?.details?.step_3 == false || authMerchant_objects.initialSetup?.details?.step_4 == false) 
                                    ?
                                    <IonCol size='2' style={{ fontSize: "16px",  textAlign: "center"}} >
                                        <a  className='flash-tutorial' onClick={() => handleHomepage()}>Home</a>
                                        <a > </a>
                                    </IonCol>
                                        :
                                    <IonCol size='2' style={{ fontSize: "16px",  textAlign: "center"}}>
                                        <a   onClick={() => handleHomepage()}>Home</a>
                                        <a > </a>
                                    </IonCol>}
                            </IonRow>}
                            </IonGrid>
                            </IonToolbar>
                            <IonToolbar className="grid_header_componentSlides" color="dark">
                                <IonGrid>
                                    <IonRow >
                                        <IonCol size='12'>
                                            <IonLabel style={{ color: "white"}}>GH-VERIFIED</IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size = '3'>
                                            <IonButton className='tab_buttons' fill={color_hotels} onClick={() => reOpenSwipe(0)}> <IonLabel>Hotels</IonLabel> </IonButton>
                                        </IonCol>
                                        <IonCol size = '3'>
                                            <IonButton className='tab_buttons' fill={color_proServices} onClick={() => reOpenSwipe(1)}> <IonLabel>Pro Services</IonLabel></IonButton>
                                        </IonCol>
                                        <IonCol size = '3'>
                                            <IonButton className='tab_buttons' fill={color_retail} onClick={() => reOpenSwipe(2)}> <IonLabel>Retail</IonLabel> </IonButton>
                                        </IonCol>
                                        <IonCol size = '3'>
                                            <IonButton className='tab_buttons' fill={color_jobs} onClick={() => reOpenSwipe(3)}> <IonLabel>Jobs</IonLabel> </IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </IonToolbar>
                            {jobsList_component == 'true' &&  
                            <IonGrid> 
                                <IonRow>
                                    <IonCol size='12'>
                                            <IonButton onClick={() => setCeateRequisitionModal(true)}> Post A Job </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>}
                </IonHeader>

              {searchHomeList != 'true' &&  <IonContent className={jobsList_component ? 'grid_content_compnentSlides_jobBoard' : 'grid_content_compnentSlides'}>

                               <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                                    <IonRefresherContent
                                    pullingText="Pull to refresh the app"
                                    refreshingSpinner="circles"
                                    refreshingText="Refreshing app..."
                                    />
                                </IonRefresher>


                    <IonSlides ref={slideRef} onIonSlideDidChange={handleSlideChange} options={slideOpts}>
                         <IonSlide className='merchantList_Content_main'>

                           {hotelList_component == 'true' && <Home_HotelsList openModal={ hotelList_component } confirmComplete={() => reRender()} ></Home_HotelsList>}

                        </IonSlide>
                        <IonSlide className='merchantList_Content_main'>
                            {proList_component == 'true' && <Home_ProfessionalServicesList openModal={ proList_component } confirmComplete={() => reRender()} ></Home_ProfessionalServicesList>}

                        </IonSlide>
                        <IonSlide className='merchantList_Content_main'>
                            {retailList_component == 'true' && <Home_RetailServicesList openModal={ retailList_component } confirmComplete={() => reRender()} ></Home_RetailServicesList>}

                        </IonSlide>
                        <IonSlide className='merchantList_Content_main_jobBoard'>
                            {jobsList_component == 'true' && 
                                <div style={{ padding: "10px" }}>

                                    <h6 style={{ fontSize: "10px" }}>Jobs in Ghana – Ghana Verified Jobs</h6>
                                    <p style={{ fontSize: "10px", lineHeight: "14px" }}>
                                        Ghana Verified Jobs is a trusted job board for Ghana, connecting job seekers with verified employers 
                                        in hospitality, retail, professional services, IT, security, and more. Search for jobs in Accra, 
                                        Somanya, Tema, Takoradi, Kumasi and all regions of Ghana. Employers can post jobs instantly and 
                                        reach thousands of candidates across Ghana. 
                                   </p>
                                    <Home_JobsList openModal={ jobsList_component } confirmComplete={() => reRender()} data={{
                                    status: "ghanaverified_site", 
                                    }}></Home_JobsList>
                                </div>
                                                        
                            }


                        </IonSlide>
                    </IonSlides>

                    <Hotel_PrivacyStatement openModal={ privacyStatementModal } closeModal={() => setPrivacyStatementModal(false)} ></Hotel_PrivacyStatement>

                    {(createRequisitionModal  == true) && <CreateRequisitionModal_Public openModal= { createRequisitionModal } closeModal={() => setCeateRequisitionModal(false)}></CreateRequisitionModal_Public>}

                    {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}
                    
                </IonContent>}


                {searchHomeList == 'true' &&   <IonContent className='grid_content_compnentSlides'>

                                   <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent
                    pullingText="Pull to refresh the app"
                    refreshingSpinner="circles"
                    refreshingText="Refreshing app..."
                    />
                </IonRefresher>

                    <IonSlides ref={slideRef} onIonSlideDidChange={handleSlideChange} className='merchantList_Slide_Dimension' options={slideOpts}>

                             <IonSlide className='merchantList_Content_main'>
                            {searchHomeList == 'true' && <Search_Home openModal={ searchHomeList } confirmComplete={() => reRender()} data={{
                                                        searchData: searchTerm, 
                                                        }}></Search_Home>}
                        </IonSlide>
                    </IonSlides>

                    <Hotel_PrivacyStatement openModal={ privacyStatementModal } closeModal={() => setPrivacyStatementModal(false)} ></Hotel_PrivacyStatement>

                    {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}

                </IonContent>}
                
                {registerModal_business == true && <RegisterBusinessModal  openModal={registerModal_business} closeModal={() => handleCloseModal()} onRegistrationCompleted={registationCompletedHandler}  data={{
                                                        source: '', 
                                                        }}></RegisterBusinessModal>}
                {registerModal_individial == true && <RegisterIndividualModal  openModal={registerModal_individial} closeModal={() => handleCloseModal()} onRegistrationCompleted={registationCompletedHandler} data={{
                                                        source: '', 
                                                        }}></RegisterIndividualModal>}

                {aboutOpen == true && <AboutModal openModal={aboutOpen} onClose={() => setAboutOpen(false)} />}

                {merchantLoginModal == true && <MerchantLoginCredentials openModal={ merchantLoginModal } closeModal={() => setMerchantLoginModal(false)} data={{
                                                        source: '', 
                                                        }}></MerchantLoginCredentials>}

                {switchAccounts_logout == true && <ConfirmMerchantLogout openModal={switchAccounts_logout} onSwitchAccounts_loggedOut={loggedOutHandler} data={{
                                            source: 'switch_accounts',
                                            acctID: acctID,
                                            schema: schema,
                                            sessionID: sessionID,
                                            baseURL: baseURL
                }}></ConfirmMerchantLogout>}

                {switchAccounts_login == true && <MerchantLoginCredentials openModal={ switchAccounts_login } closeModal={() => setSwitchAccounts_login(false)} data={{
                                                        source: 'switch_accounts', 
                                                        username: selectedAccountUsername,
                                                        password: selectedAccountPassword,
                                                        }}></MerchantLoginCredentials>}


                { showAlert == true && <IonAlert
                    isOpen={showAlert}
                    header="Confirm"
                    message="ARE YOUR REGISTERING AS A BUSINESS?"
                    buttons={[
                    {
                        text: "No",
                        handler: () => handleRegister_individual(),
                    },
                    {
                        text: "Yes",
                        handler: () => handleRegister_business(),
                    },
                    ]}
                    onDidDismiss={() => setShowAlert(false)}
                />}

                 {jobsList_component != 'true' && <IonFooter class='appFooter'>
                    <IonGrid>
                        <IonRow className='gh_bottom_links_row'>
                           {/*} {(authMerchant_objects.authenticated != null && authMerchant_objects.acctID == "G1") &&
                                <IonCol size='1'>
                                    <IonButton className='small_button' onClick={() => handleHomepage_zasava()}>Zasava</IonButton>
                                </IonCol>
                            }*/}
                                <IonCol size='8'>
                                    <input 
                                    className='professional-input'
                                    type='text' 
                                    id='searchSupplierName' 
                                    value={ searchTerm } 
                                    placeholder='Search Merchant' 
                                    debounce={500}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSearchTerm(value);
                                        // Get all datalist options
                                        const dataList = document.getElementById('searchSupplierNameList');
                                        const options = Array.from(dataList.getElementsByTagName('option'));
                        
                                        // Check if selected value exists in datalist options
                                        const isValidSelection = options.some(option => option.value === value);
                        
                                        if (isValidSelection) {
                                            handleInput(['search_home', value]); // Fire only if selected
                                        }
                                    }}
                                    list='searchSupplierNameList' 
                                    autocomplete='off' 
                                    clearInput // Optional: Adds a clear button inside the input
                                    required></input>
                                    <datalist id='searchSupplierNameList'>
                                        {searchResults.map((result) => (
                                            <option key={result.id} value={result.companyName}></option>
                                        ))}
                                    </datalist>
                                   {/*} <IonInput
                                    value={searchTerm}
                                    onIonInput={handleSearch}
                                    debounce={500}
                                    placeholder="Enter search"
                                    clearInput // Optional: Adds a clear button inside the input
                                    />*/}
                                </IonCol>
                                <IonCol size='2'>
                                    <IonButton 
                                        className='professional-button'
                                        fill="clear"
                                        onClick={() => {
                                            const inputElement = document.getElementById('searchSupplierName');
                                            const selectedValue = inputElement.value;
                            
                                            // Check again if the value exists in the datalist

                                            handleInput(['search_home', selectedValue]); // Fire only if valid
                                        }}
                                    >
                                    </IonButton>
                                </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonFooter>}
            </React.Fragment>

        );
}


